/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { createRef, Fragment } from 'react'

export function AuthenticatedLink ({ url, filename, children }) {
  const link = createRef()
  const token = localStorage.getItem('token');
  const handleAction = async () => {
    if (link.current.href) { return }
  
    const result = await fetch(url, {	
      headers: new Headers({ Authorization: `Bearer ${token}` })
    })
    
    const blob = await result.blob()
    const href = window.URL.createObjectURL(blob)
    
    link.current.download = filename
    link.current.href = href
      
    link.current.click()
  }

  return (
    <Fragment>
      <a ref={link} onClick={handleAction}>{children}</a>
    </Fragment>
  )
}